module.exports = function getResource(label, vars = []) {
    let resources = {
        byClicking: 'En cliquant sur « S’inscrire », vous reconnaissez être résident du Canada ou des États-Unis et (1) avez lu la',
        privacyPolicy: 'politique de confidentialité',
        termsOfUse: 'les conditions d’utilisation et les',
        and: 'et ',
        agreeTo: ' acceptez les conditions d’utilisation, ',
        noticeFinancialIncentive: 'l’avis d’incitatif financier de Sephora',
        biTerms: 'modalités du programme Beauty Insider',
        receiveOffers: 'et de recevoir automatiquement les offres Beauty Insider ainsi que ' +
            'des notifications par courriel.',
        sephoraReCaptchaText: 'Sephora utilise ReCaptcha et les utilisateurs sont assujettis',
        sephoraReCaptchaTextRegister: 'Sephora utilise ReCaptcha, et en s’enregistrant, les utilisateurs sont assujettis aux normes de Google en matière de',
        googlePrivacyPolicyLink: 'politique de confidentialité',
        googleTermsLink: 'conditions'
    };
    return resources[label];
};
